export default {
    data() {
        return {
            keyword: ''
        };
    }
}